module.exports = __webpack_public_path__ + "img/instaLogo.783a38f2.svg";